import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import Certificate from './Component/Certificate'
import HeaderTmp from '../Template/HeaderTmp'
import Footer from '../Template/FooterTmp'
import { Redirect } from 'react-router-dom'
import { Layout, Row, Col, Button } from 'antd'
import './Slip.css'

const { Content } = Layout

class Slip extends Component {
  componentDidMount() {
    // document.title = "e-Slip - Powered By Thai.run"
    const tail = this.props.data.variables.slug.split('-')
    const title = tail[tail.length - 1] === 'ecer' ? 'e-Certificate - Powered By Thai.run' : 'e-Slip - Powered By Thai.run'
    document.title = title
  }

  render() {
    if (!this.props.data.event) {
      return <span ><Button type="primary" style={{ marginLeft: '48%', marginTop: '22%' }} shape="circle" loading /></span>
    }
    if (this.props.data.event.eSlip === false) {
      return <Redirect to="/" />
    }
    const { event } = this.props.data
    const { bib } = this.props.match.params
    return (
      <Layout>
        <HeaderTmp />
        <Row type="flex" justify="center">
          <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16} >
            <Content style={{
  marginTop: 96, minHeight: 'calc(100vh - 100px - 69px - 37px)', background: '#f2f2f2', textAlign: 'center',
}}
            >
              <Certificate event={event.event} bib={parseInt(bib, 10)} slug={this.props.match.params.slug} />
            </Content>
          </Col>
        </Row>
        <Footer />
      </Layout>
    )
  }
}

const SlipQuery = gql`
   query queryEvent($slug: String) {
        event(filter: {
            slug: $slug
        }) {
            event
            slug
            title
            partner
            logoImage
            eSlip
            _id
        }
    }
`
const SlipWithData = graphql(SlipQuery, {
  options: props => ({
    variables: {
      slug: props.match.params.slug,
    },
  }),
})(Slip)

export default SlipWithData



// WEBPACK FOOTER //
// ./src/Slip/Slip.js